/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

 import { Inject, Injectable, Optional }                      from '@angular/core';
 import { HttpClient, HttpHeaders, HttpParams,
          HttpResponse, HttpEvent }                           from '@angular/common/http';
 import { CustomHttpUrlEncodingCodec }                        from '../encoder';

 import { Observable }                                        from 'rxjs';

 import { UserEditDto } from '../model/userEditDto';
 import { UserInputDto } from '../model/userInputDto';
 import { UserOutputDto } from '../model/userOutputDto';
 import { UserReportAdminDto } from '../model/userReportAdminDto';
 import { UserRequestDto } from '../model/userRequestDto';
 import { UserResponseDto } from '../model/userResponseDto';
 import { UpdateUserPushTokenRequest } from '../model/updateUserPushTokenRequest';


 import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
 import { Configuration }                                     from '../configuration';


 @Injectable()
 export class UserService {

     protected basePath = '/';
     public defaultHeaders = new HttpHeaders();
     public configuration = new Configuration();

     constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
         if (basePath) {
             this.basePath = basePath;
         }
         if (configuration) {
             this.configuration = configuration;
             this.basePath = basePath || configuration.basePath || this.basePath;
         }
     }

     /**
      * @param consumes string[] mime-types
      * @return true: consumes contains 'multipart/form-data', false: otherwise
      */
     private canConsumeForm(consumes: string[]): boolean {
         const form = 'multipart/form-data';
         for (const consume of consumes) {
             if (form === consume) {
                 return true;
             }
         }
         return false;
     }


     /**
      *
      *
      * @param body
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public apiUserEditUserDataPut(body?: UserEditDto, observe?: 'body', reportProgress?: boolean): Observable<UserOutputDto>;
     public apiUserEditUserDataPut(body?: UserEditDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserOutputDto>>;
     public apiUserEditUserDataPut(body?: UserEditDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserOutputDto>>;
     public apiUserEditUserDataPut(body?: UserEditDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


         let headers = this.defaultHeaders;

         // authentication (Bearer) required
         if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
             headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
         }

         // to determine the Accept header
         let httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
             'application/json',
             'text/json',
             'application/_*+json'
         ];
         const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
         if (httpContentTypeSelected != undefined) {
             headers = headers.set('Content-Type', httpContentTypeSelected);
         }

         return this.httpClient.request<UserOutputDto>('put',`${this.basePath}/api/User/EditUserData`,
             {
                 body: body,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      *
      *
      * @param cdUser
      * @param favStore
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public apiUserFavoritePost(cdUser?: number, favStore?: number, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
     public apiUserFavoritePost(cdUser?: number, favStore?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
     public apiUserFavoritePost(cdUser?: number, favStore?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
     public apiUserFavoritePost(cdUser?: number, favStore?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



         let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
         if (cdUser !== undefined && cdUser !== null) {
             queryParameters = queryParameters.set('cdUser', <any>cdUser);
         }
         if (favStore !== undefined && favStore !== null) {
             queryParameters = queryParameters.set('favStore', <any>favStore);
         }

         let headers = this.defaultHeaders;

         // authentication (Bearer) required
         if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
             headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
         }

         // to determine the Accept header
         let httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.request<boolean>('post',`${this.basePath}/api/User/Favorite`,
             {
                 params: queryParameters,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      *
      *
      * @param email
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public apiUserForgotPost(email?: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
     public apiUserForgotPost(email?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
     public apiUserForgotPost(email?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
     public apiUserForgotPost(email?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


         let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
         if (email !== undefined && email !== null) {
             queryParameters = queryParameters.set('Email', <any>email);
         }

         let headers = this.defaultHeaders;

         // authentication (Bearer) required
         if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
             headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
         }

         // to determine the Accept header
         let httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.request<boolean>('post',`${this.basePath}/api/User/Forgot`,
             {
                 params: queryParameters,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      *
      *
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public apiUserGetAllGet(observe?: 'body', reportProgress?: boolean): Observable<Array<UserReportAdminDto>>;
     public apiUserGetAllGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserReportAdminDto>>>;
     public apiUserGetAllGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserReportAdminDto>>>;
     public apiUserGetAllGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

         let headers = this.defaultHeaders;

         // authentication (Bearer) required
         if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
             headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
         }

         // to determine the Accept header
         let httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.request<Array<UserReportAdminDto>>('get',`${this.basePath}/api/User/GetAll`,
             {
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      *
      *
      * @param cdUser
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public apiUserGetByIdGet(cdUser?: number, observe?: 'body', reportProgress?: boolean): Observable<UserOutputDto>;
     public apiUserGetByIdGet(cdUser?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserOutputDto>>;
     public apiUserGetByIdGet(cdUser?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserOutputDto>>;
     public apiUserGetByIdGet(cdUser?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


         let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
         if (cdUser !== undefined && cdUser !== null) {
             queryParameters = queryParameters.set('cdUser', <any>cdUser);
         }

         let headers = this.defaultHeaders;

         // authentication (Bearer) required
         if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
             headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
         }

         // to determine the Accept header
         let httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.request<UserOutputDto>('get',`${this.basePath}/api/User/GetById`,
             {
                 params: queryParameters,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      *
      *
      * @param body
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public apiUserLoginPost(body?: UserRequestDto, observe?: 'body', reportProgress?: boolean): Observable<UserResponseDto>;
     public apiUserLoginPost(body?: UserRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserResponseDto>>;
     public apiUserLoginPost(body?: UserRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserResponseDto>>;
     public apiUserLoginPost(body?: UserRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


         let headers = this.defaultHeaders;

         // authentication (Bearer) required
         if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
             headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
         }

         // to determine the Accept header
         let httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
             'application/json',
             'text/json',
             'application/_*+json'
         ];
         const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
         if (httpContentTypeSelected != undefined) {
             headers = headers.set('Content-Type', httpContentTypeSelected);
         }

         return this.httpClient.request<UserResponseDto>('post',`${this.basePath}/api/User/Login`,
             {
                 body: body,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
      *
      *
      * @param body
      * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
      * @param reportProgress flag to report request and response progress.
      */
     public apiUserPostPost(body?: UserInputDto, observe?: 'body', reportProgress?: boolean): Observable<UserResponseDto>;
     public apiUserPostPost(body?: UserInputDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserResponseDto>>;
     public apiUserPostPost(body?: UserInputDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserResponseDto>>;
     public apiUserPostPost(body?: UserInputDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


         let headers = this.defaultHeaders;

         // authentication (Bearer) required
         if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
             headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
         }

         // to determine the Accept header
         let httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
             'application/json',
             'text/json',
             'application/_*+json'
         ];
         const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
         if (httpContentTypeSelected != undefined) {
             headers = headers.set('Content-Type', httpContentTypeSelected);
         }

         return this.httpClient.request<UserResponseDto>('post',`${this.basePath}/api/User/Post`,
             {
                 body: body,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

     /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiUserUpdatePushTokenPut(body?: UpdateUserPushTokenRequest, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiUserUpdatePushTokenPut(body?: UpdateUserPushTokenRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiUserUpdatePushTokenPut(body?: UpdateUserPushTokenRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiUserUpdatePushTokenPut(body?: UpdateUserPushTokenRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<boolean>('put',`${this.basePath}/api/User/UpdatePushToken`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
 }
